var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceVerification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 210,
    viewBox: "0 0 142 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_318)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.332 -1.4611L43.1929 -29.7033C41.8748 -30.0989 40.4695 -30.0989 39.1513 -29.7033L-54.9895 -1.4611C-56.4378 -1.02653 -57.7074 -0.136673 -58.61 1.07646C-59.5125 2.2896 -60 3.76137 -60 5.27343V108.828C-60 122.297 -54.547 136.085 -43.7934 149.808C-35.5805 160.289 -24.2175 170.814 -10.0214 181.091C13.8271 198.354 37.311 208.944 38.2991 209.386C39.2028 209.791 40.1819 210 41.1721 210C42.1624 210 43.1414 209.791 44.0451 209.386C45.0327 208.944 68.5162 198.354 92.3647 181.091C106.561 170.814 117.923 160.289 126.137 149.808C136.89 136.085 142.342 122.297 142.342 108.828V5.27343C142.343 3.76132 141.855 2.28943 140.953 1.07625C140.05 -0.136925 138.78 -1.02673 137.332 -1.4611Z",
    fill: "#C6B9FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.866 12.4172L43.0102 -11.54C41.892 -11.8756 40.7 -11.8756 39.5818 -11.54L-40.2756 12.4172C-41.5042 12.7858 -42.5811 13.5406 -43.3467 14.5697C-44.1124 15.5988 -44.5259 16.8473 -44.5259 18.1299V105.973C-44.5259 117.398 -39.9003 129.094 -30.7783 140.735C-23.8114 149.626 -14.1725 158.554 -2.13026 167.271C18.0999 181.915 38.0207 190.899 38.8589 191.274C39.6255 191.617 40.456 191.795 41.296 191.795C42.136 191.795 42.9665 191.617 43.7331 191.274C44.5709 190.899 64.4913 181.915 84.7215 167.271C96.7637 158.554 106.402 149.626 113.369 140.735C122.491 129.094 127.116 117.398 127.116 105.973V18.1299C127.116 16.8472 126.703 15.5987 125.937 14.5695C125.172 13.5404 124.095 12.7856 122.866 12.4172Z",
    fill: "#C6B9FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.185 26.3303L42.5011 6.62464C41.5814 6.34859 40.6009 6.34859 39.6812 6.62464L-26.0045 26.3303C-27.015 26.6335 -27.9009 27.2544 -28.5306 28.1008C-29.1604 28.9473 -29.5005 29.9742 -29.5005 31.0292V103.283C-29.5005 112.681 -25.6957 122.301 -18.1926 131.877C-12.4621 139.19 -4.5337 146.533 5.37145 153.704C22.0115 165.749 38.3971 173.138 39.0866 173.446C39.7171 173.729 40.4002 173.875 41.0911 173.875C41.7821 173.875 42.4652 173.729 43.0957 173.446C43.7849 173.138 60.1701 165.749 76.8102 153.704C86.7153 146.533 94.6434 139.19 100.374 131.877C107.877 122.301 111.681 112.681 111.681 103.283V31.0292C111.682 29.9741 111.342 28.9472 110.712 28.1007C110.082 27.2542 109.196 26.6333 108.185 26.3303Z",
    fill: "#C6B9FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.9464 39.8505L42.2203 24.3325C41.4961 24.1151 40.7239 24.1151 39.9997 24.3325L-11.7274 39.8505C-12.5232 40.0893 -13.2208 40.5783 -13.7167 41.2448C-14.2126 41.9114 -14.4805 42.7201 -14.4805 43.5509V100.45C-14.4805 107.851 -11.4843 115.427 -5.57555 122.968C-1.06282 128.727 5.18073 134.51 12.981 140.156C26.0849 149.642 38.9885 155.461 39.5314 155.703C40.028 155.926 40.5659 156.041 41.11 156.041C41.6541 156.041 42.1921 155.926 42.6886 155.703C43.2313 155.461 56.1346 149.642 69.2385 140.156C77.0388 134.51 83.2821 128.727 87.795 122.968C93.7038 115.427 96.6994 107.851 96.6994 100.45V43.5509C96.6996 42.7201 96.4318 41.9113 95.9358 41.2447C95.4399 40.5781 94.7422 40.0892 93.9464 39.8505Z",
    fill: "#C6B9FF",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 63.1764V62.4444C16 57.7807 19.7807 54 24.4444 54H24.9412",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 76.8236V77.5556C16 82.2193 19.7807 86 24.4444 86H24.9412",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7646 63.1764V62.4444C47.7646 57.7807 43.9839 54 39.3202 54H38.8235",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7646 76.8236V77.5556C47.7646 82.2193 43.9839 86 39.3202 86H38.8235",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5091 76.7363V76.7363C35.1386 78.2342 31.2914 78.2342 27.9209 76.7363V76.7363",
    stroke: "#3936EF",
    strokeOpacity: 0.4,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9146 64.9716V70.0219C33.9146 71.3504 32.9851 72.4978 31.6855 72.7735V72.7735",
    stroke: "#3936EF",
    strokeOpacity: 0.4,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5093 64.9716L26.5093 67.758",
    stroke: "#3936EF",
    strokeOpacity: 0.4,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1562 64.9716L40.1562 67.758",
    stroke: "#3936EF",
    strokeOpacity: 0.4,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1722 76.7363V76.7363C33.8017 78.2342 29.9544 78.2342 26.584 76.7363V76.7363",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5777 64.9716V70.0219C32.5777 71.3504 31.6482 72.4978 30.3486 72.7735V72.7735",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1724 64.9716L25.1724 67.758",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8193 64.9716L38.8193 67.758",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 210,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceVerification);
export default __webpack_public_path__ + "static/media/FaceVerification.729ed3d65856843cf7ee6d91b93bcb3f.svg";
export { ForwardRef as ReactComponent };